import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { useTranslation } from 'react-i18next';
import {
	ChangeDishPositionContext,
	IChangeDishPositionContext,
} from '../../../../../changeDishPositionState/changeDishPositionContext';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { getCategoriesShortInfoV2 } from 'backend/categories';
import style from './CategorySelect.module.scss';

const { Option } = Select;

export const CategorySelect: React.FC = () => {
	const { setIDCategory, IDSelectedRestaurant, IDSelectedCategory } =
		useContext<IChangeDishPositionContext>(ChangeDishPositionContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(IDSelectedRestaurant ? getCategoriesShortInfoV2 : null, { restaurantIds: [IDSelectedRestaurant || ''] });
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedRestaurant]);

	return (
		<div className={style.container}>
			<Text translationNameSpace="listing" translationKey="categoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDCategory}
				value={IDSelectedCategory}
				loading={loading}
				listItemHeight={response?.data.categories.length}
				allowClear={true}
				disabled={!IDSelectedRestaurant || loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.categories.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response?.data.categories.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};
